import React from 'react';

const ambiente = {
    "dev": {
        contextName: "Desenvolvimento",
        links: {
            "emitir-nfe": "http://localhost:9001/#/emitir-nfe?id=:id"
        },
        appBarNavigation: {
            url: "http://localhost:3100"
        },
        apis: [{
            nome: "contas",
            url: 'http://localhost:8081/emitir-notas/acessos',
            isPrivate: true
        }, {
            nome: "emitirNotas",
            url: 'http://localhost:8081/emitir-notas/:empresa',
            isPrivate: true
        }]       
    }, 
    "prod": {
        contextName: "Producao",
        appBarNavigation: {
            url: "https://sidebar-apps-prod.contentsys.com.br"
        },
        links: {
            "emitir-nfe": "https://nfe.contentsys.com.br#/emitir-nfe?id=:id"
        },
        apis: [{
            nome: 'contas',
            url: "https://api.contentsys.com.br/en/acessos",
            isPrivate: true
        },{
            nome: "emitirNotas",
            url: 'https://api.contentsys.com.br/en/:empresa',
            isPrivate: true
        }]
            
    },
    "test": {
        contextName: "Teste",
        links: {
            "emitir-nfe": "http://localhost:8080/#/"
        },
        appBarNavigation: {
            url: "https://sidebar-apps-test.contentsys.com.br"
        },
        apis: [{
            nome: 'contas',
            url: "https://api.contentsys.com.br/en-test/acessos",
            isPrivate: true
        },{
            nome: "emitirNotas",
            url: 'https://api.contentsys.com.br/en-test/:empresa',
            isPrivate: true
        }]    
        
            
        
    }
}

const reactAppEnv = process.env.REACT_APP_ENV;

const ambienteContext = React.createContext(ambiente[reactAppEnv]);

export {ambienteContext};
